export const SET_AUTH = 'auth/SET';

export const setAuth = payload => ({
  type: SET_AUTH,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/set-auth.js